import { useEffect } from 'react';
import { handleOAuthSignIn, pollForGoogle } from './auth.utils';

const GOOGLE_CLIENT_IDS = {
  'si.com':
    '463477417652-hutbmku64c94svf03itqrno88ljmmpsc.apps.googleusercontent.com',
  'mentalfloss.com': '714792666811-lk0d9knqbktb95rt17kbdoc4074bmn85.apps.googleusercontent.com',
  // FanSided and FanSided network id
  default:
    '102936792104-jftdt1qtikefs9ac4barqnbt1g6b9f5i.apps.googleusercontent.com',
} as const;

const getClientId = (url: string): string => {
  if (url.includes('si.com')) {
    return GOOGLE_CLIENT_IDS['si.com'];
  }
  if (url.includes('mentalfloss.com')) {
    return GOOGLE_CLIENT_IDS['mentalfloss.com'];
  }
  return GOOGLE_CLIENT_IDS.default;
};

export const GoogleOAuth = ({ propertyUrl }: {propertyUrl?: string}) => {
  useEffect(() => {
    if (!propertyUrl) {
      return;
    }

    const initializeGoogle = async () => {
      try {
        await pollForGoogle();

        window.google.accounts.id.initialize({
          client_id: getClientId(propertyUrl),
          callback: (response: any) => handleOAuthSignIn('google', response),
          auto_select: false,
          cancel_on_tap_outside: false,
        });

        window.google.accounts.id.prompt();
      } catch (error) {
        console.error('Failed to initialize Google OAuth:', error);
      }
    };

    initializeGoogle();
  }, [propertyUrl]);

  return null;
};
